import React, {useEffect, useState, useRef} from 'react'
import {Link} from 'react-router-dom'
import {KTIcon} from '../../../_metronic/helpers'
import {LoadingData} from '../../../components/LoadingData'
import {Pagination} from '../../../components/Pagination'
import {useAuth} from '../../modules/auth'
import {getReferentielsTypePieces, getSiteAll, importReferenciel, importSite} from '../../../components/requests'
import {ModeleReferentielTypePiece} from '../../../components/Models'
import {shouldDisplayFonctionnalite} from '../../../components/helpers'
import {useFormik} from 'formik'
import LierReferentielSiteModal from "./components/LierReferentielSiteModal";

const ReferentielTypePieceListPage = () => {
  const [dataReferentielTypePiece, setDataReferentielTypePiece] = useState<Array<ModeleReferentielTypePiece>>([])
  const [allTypePiece, setAllTypePiece] = useState<Array<ModeleReferentielTypePiece>>([])
  const [loading, setLoading] = useState(false)
  const [loadingSite, setLoadingSite] = useState(false)
  const [nombreDePages, setNombreDePages] = useState<number>(0)
  const [totalPages, setTotalPages] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const [searchPage, setSearchPage] = useState<string>('')
  const [sites, setSites] = useState<any>([])
  const [isSearch, setIsSearch] = useState(false)
  const {currentUser} = useAuth()

  // Recuperation de la liste de réfenretielTypePiece et mise a jour sur chaque changement de page
  useEffect(() => {
    getReferentielTypePieceData()
  }, [currentPage, searchPage])

  // Recuperation de la liste de site pour le formulaire de selection de site
  useEffect(() => {
    getAllSites()
  }, []);

  // Méthode de récupération des référentiels
  const getReferentielTypePieceData = () => {
    setLoading(true)
    getReferentielsTypePieces(!isSearch ? currentPage : 1, searchPage)
      .then((referentielTypePieceRequest) => {
        setNombreDePages(referentielTypePieceRequest?.pages)
        setTotalPages(referentielTypePieceRequest?.total)
        setCurrentPage(referentielTypePieceRequest?.page)
        if (referentielTypePieceRequest?.data !== undefined) {
          setDataReferentielTypePiece(referentielTypePieceRequest?.data)
          setAllTypePiece(referentielTypePieceRequest?.allReferencementTypePiece)
          setLoading(false)
          setIsSearch(false)
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }

  // Méthode de récupération des sites
  const getAllSites = () => {
    setLoadingSite(true)
    getSiteAll()
      .then((response) => {
        const transformedData = response.map((item) => ({
          value: item.id,
          label: item.nom ?? item.code,
        }))
        setSites([...transformedData])
      })
      .catch(() => console.error('Erreur'))
      .finally(() => setLoadingSite(false))
  }

  const fileInputRef = useRef<any>(null)
  const handleFileChange = (e) => {
    setLoading(true)
    const file = e.target.files[0]
    if (file) {
      const formData: FormData = new FormData()
      formData.append('file', file)
      importReferenciel(formData)
        .then((response) => {
          if (response.status === 200 && response.data.status === 'success') {
            getReferentielTypePieceData()
          } else {
            setLoading(false)
          }
        })
        .catch((error) => {
          console.error(error)
        })
      fileInputRef.current.value = null
    } else {
      setLoading(false)
    }
  }

  const fileSiteInputRef = useRef<any>(null)
  const handleFileSiteChange = (e) => {
    setLoading(true)
    const file = e.target.files[0]
    if (file) {
      const formData: FormData = new FormData()
      formData.append('file', file)
      importSite(formData)
        .then((response) => {
          if (response.status === 200 && response.data.status === 'success') {
            getReferentielTypePieceData()
          } else {
            setLoading(false)
          }
        })
        .catch((error) => {
          console.error(error)
        })
      fileSiteInputRef.current.value = null
    } else {
      setLoading(false)
    }
  }

  const formik = useFormik({
    initialValues: {search: ''},
    onSubmit: (values, {setSubmitting}) => {
      setTimeout(() => {
        setSearchPage(values.search)
      }, 1000)
    },
  })

  return (
    <>
      {/* begin::Row  */}
      <div className='row g-5 g-xl-8'>
        {/* begin::Col  */}
        <div className='col-xxl-12'>
          <div className={`card card-xxl-stretch mb-5 mb-xl-8`}>
            {/* begin::Header */}
            <div className='card-header border-0 pt-5 justify-content-end'>
              <div className='d-flex justify-content-between align-items-center gap-2'>
                <div>
                  <button
                    type='button'
                    className='btn btn-sm btn-light-success'
                    data-bs-target='#referentielSiteModal'
                    data-bs-toggle='modal'
                  >
                    <KTIcon iconName='setting-4' className='fs-3 me-1'/>
                    Lier à un site
                  </button>
                </div>
                <div
                  className='card-toolbar'
                  data-bs-toggle='tooltip'
                  data-bs-placement='top'
                  data-bs-trigger='hover'
                  title='Cliquez pour importer les référentiels type pièce'
                >
                  <button
                    onClick={() => {
                      fileSiteInputRef.current.click()
                    }}
                    className='btn btn-sm btn-light-primary'
                  >
                    <KTIcon iconName='plus' className='fs-3 me-1'/>
                    Importer site
                  </button>
                  <input
                    type='file'
                    ref={fileSiteInputRef}
                    onChange={handleFileSiteChange}
                    style={{display: 'none'}}
                  />
                </div>
                {shouldDisplayFonctionnalite(currentUser, 'IMPORTER REF TYPE PIECE') && (
                  <div
                    className='card-toolbar'
                    data-bs-toggle='tooltip'
                    data-bs-placement='top'
                    data-bs-trigger='hover'
                    title='Cliquez pour importer les référentiels type pièce'
                  >
                    <button
                      onClick={() => {
                        fileInputRef.current.click()
                      }}
                      className='btn btn-sm btn-light-primary'
                    >
                      <KTIcon iconName='plus' className='fs-3 me-1'/>
                      Importer synonyme
                    </button>
                    <input
                      type='file'
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{display: 'none'}}
                    />
                  </div>
                )}
              </div>
            </div>
            {/* end::Header */}
            {/* debut champs recherche */}
            <form className='card-header border-0 pt-5 pb-5' onSubmit={formik.handleSubmit}>
              <div></div>
              <div className='form-group d-flex col-lg-4'>
                <div className='input-group'>
                  <input
                    type='text'
                    className='form-control h-100'
                    {...formik.getFieldProps('search')}
                    name='search'
                    placeholder='Rechercher un nom de type pièce'
                  />
                  <button
                    type='submit'
                    className='btn btn-light border-0 input-group-append h-100'
                    onClick={() => setIsSearch(true)}
                  >
                    <i className='fas fa-search text-secondary fs-1'></i>
                  </button>
                </div>
              </div>
            </form>
            {/* fin champs recherche */}

            {(loading || loadingSite) ? (
              <LoadingData/>
            ) : (
              <>
                {shouldDisplayFonctionnalite(currentUser, 'VOIR REF TYPE PIECE') && (
                  <div className='card-body py-3'>
                    {/* begin::Table container */}
                    <div className='table-responsive'>
                      {/* begin::Table */}
                      <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                        {/* begin::Table head */}
                        <thead>
                        <tr className='fw-bold text-muted'>
                          <th style={{width: '35%'}}>Nom pièce</th>
                          <th style={{width: '10%'}}>Numéro</th>
                          <th style={{width: '40%'}}>Synonyme</th>
                          <th style={{width: '15%'}}>Sites</th>
                          <th style={{width: '10%'}}>Disponibilité(h)</th>
                          <th className='text-end' style={{width: '10%'}}>
                            Actions
                          </th>
                        </tr>
                        </thead>
                        {/* end::Table head */}
                        {/* begin::Table body */}
                        <tbody>
                        {dataReferentielTypePiece.length ? (
                          dataReferentielTypePiece.map((refTypePiece) => {
                            return (
                              <tr key={refTypePiece.id}>
                                <td>
                                  <div className='d-flex align-items-center'>
                                    <div className='d-flex justify-content-start flex-column fw-bold'></div>
                                    {refTypePiece?.nomTypePiece}
                                  </div>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'></p>
                                  {refTypePiece?.numero}
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'></p>
                                  <>
                                    {Array.isArray(refTypePiece?.referencement)
                                      ? refTypePiece.referencement.length > 20
                                        ? `${refTypePiece.referencement
                                          .slice(0, 20)
                                          .join(', ')}, ...`
                                        : refTypePiece.referencement.join(', ')
                                      : Object.values(refTypePiece?.referencement ?? {}).length >
                                      20
                                        ? `${Object.values(refTypePiece?.referencement ?? {})
                                          .slice(0, 20)
                                          .join(', ')}, ...`
                                        : Object.values(refTypePiece?.referencement ?? {}).join(
                                          ', '
                                        )}
                                  </>
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'></p>
                                  {refTypePiece?.sites?.map((site) => site?.nom)?.join(', ') ?? ''}
                                </td>
                                <td>
                                  <p className='text-dark fw-bold text-hover-primary d-block fs-6 mb-0'></p>
                                  {refTypePiece?.dureeDisponibilite ?? '24'}
                                </td>
                                <td>
                                  <div className='d-flex justify-content-end flex-shrink-0'>
                                    <Link
                                      to={`/referentiel-type-piece/${refTypePiece.idRefTypePiece}/modifier/${refTypePiece.idTypePiece}`}
                                      className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      state={{sites}}
                                    >
                                      <i className='bi bi-pencil-square fs-2'></i>
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            )
                          })
                        ) : (
                          <tr>
                            <td colSpan={6} className='text-center'>
                              Aucun résultat trouvé
                            </td>
                          </tr>
                        )}
                        </tbody>
                        {/* end::Table body */}
                      </table>
                      {/* end::Table */}
                    </div>
                    {/* end::Table container */}

                    {/* begin::pagination*/}
                    <Pagination
                      totalPages={totalPages}
                      nombreDePages={nombreDePages}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      locationState={0}
                    />
                    {/* end::pagination*/}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
        {/* end::Col  */}

        <LierReferentielSiteModal
          allTypePiece={allTypePiece}
          sites={sites}
          setDataReferentielTypePiece={setDataReferentielTypePiece}
        />
      </div>
      {/* end::Row  */}
    </>
  )
}

export {ReferentielTypePieceListPage}
